import { Scores } from "./TeamScoreModel";
import { entities } from "sbtech-sports-data-api-client";
import { ParserHelper } from "../ParserHelper";

export class TeamTennisScoreParser {
    private static _instance: TeamTennisScoreParser;

    private constructor() { }

    public static get instance(): TeamTennisScoreParser {
        if (!TeamTennisScoreParser._instance) {
            TeamTennisScoreParser._instance = new TeamTennisScoreParser();
        }
        return TeamTennisScoreParser._instance;
    }

    public parse(sportEvent: entities.SportEvent): Scores {
        let currentGameScore1 = ParserHelper.instance.getAdditionalScore(sportEvent, "currentGameScore1");
        let currentGameScore2 = ParserHelper.instance.getAdditionalScore(sportEvent, "currentGameScore2");

        return !sportEvent.isTeamSwap
            ? { Home: currentGameScore1, Away: currentGameScore2 }
            : { Home: currentGameScore2, Away: currentGameScore1 };
    }
};